import { useEffect, useState } from 'react';

import { useT } from '@/i18n';
import { readHideFromCapture, setHideFromCapture, windowPrivacyAvailable } from '@/lib/windowPrivacy';

import styles from './QuickSendSettings.module.css';
import { SwitchRow } from './SwitchRow';

/**
 * The Mac app's switch for showing nothing of its window in screen recordings and screen sharing. Where the shell does
 * not offer it (a browser, iPhone, iPad) it draws nothing.
 */
export function WindowPrivacySettings(): React.JSX.Element | null {
  const t = useT();
  const [hide, setHide] = useState<boolean | null>(null);
  useEffect(() => {
    let cancelled = false;
    void readHideFromCapture().then((value) => {
      if (!cancelled) setHide(value);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  if (!windowPrivacyAvailable() || hide === null) return null;
  return (
    <div className={styles.group} data-testid="window-privacy-settings">
      <SwitchRow
        label={t('windowPrivacy.label')}
        hint={t('windowPrivacy.hint')}
        checked={hide}
        onChange={(on) => {
          setHide(on);
          void setHideFromCapture(on).then((now) => {
            if (now !== null) setHide(now);
          });
        }}
        data-testid="window-privacy-switch"
      />
    </div>
  );
}
